/**
 * True when the user has highlighted page text (not just a collapsed caret).
 *
 * Canvas shortcuts own Ctrl/Cmd+C for layout elements, which would otherwise
 * swallow the browser's copy for any text the user selected in a panel.
 */
export function hasTextSelection(): boolean {
  if (typeof window === 'undefined') return false;
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed) return false;
  return selection.toString().trim().length > 0;
}
